import React from 'react'
import { Box } from '@mui/material'
import LogoMarkImage from '../../assets/svg/logomark.svg'

const CadsoftLogoMark = (props) => {
  return (
    <Box
      component="img"
      height={props.height}
      src={LogoMarkImage}
      width={props.width}
      alt="Cadsoft Logo Mark"
      sx={{
        lineHeight: props.lineHeight,
        marginX: props.marginX,
        marginRight: props.marginRight,
        padding: props.padding,
        paddingX: props.paddingX,
      }}
    >
    </Box>
  )
}

export default CadsoftLogoMark